import type { ComponentType, ReactNode } from 'react';
import React, { Fragment } from 'react';
import { Br } from '@alfa-bank/site-br';

/**
 * Хелпер для создания многострочного текста
 * @param content контент - обрабатывается только текст и массивы в arrayMode
 * @param wrapper кастомная обертка
 * @param arrayMode режим работы с массивами - для совместимости со старым хелпером
 * getMultiLineText
 */
export const parseNewLines = (
    content?: ReactNode,
    wrapper?: ComponentType,
    arrayMode = false
): ReactNode | ReactNode[] => {
    if (!content) return '';
    const WrapperComponent = wrapper ?? Fragment;
    const isArray = arrayMode && Array.isArray(content);
    if (typeof content !== 'string' && !isArray) return content;

    const arr = isArray ? (content as string[]) : (content as string).split(/\\n|\n/);

    return arr.map((item, index) => (
        <WrapperComponent key={index}>
            {typeof item === 'string' ? item.trim() : item}
            {index < arr.length - 1 && <Br />}
        </WrapperComponent>
    ));
};
